import { useQuery } from '@tanstack/react-query';
import { fetchLocalContentGenres } from './apiFetchLocalContentGenres';

export const LOCAL_CONTENT_GENRES_QUERY = 'localContentGenres';
export const useLocalContentGenres = () => {
    const genres = useQuery([LOCAL_CONTENT_GENRES_QUERY], fetchLocalContentGenres);

    return {
        ...genres,
        localContentGenres: genres.data?.localContentGenres,
        standardGenres: genres.data?.standardGenres,
        defaultGenre: genres.data?.localContentGenres?.[0].id ?? genres.data?.standardGenres?.[0].id
    };
};
